import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllVehicleCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleCategory}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getVehicleCategoryById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.VehicleCategory}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertVehicleCategory = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.VehicleCategory, input);
  return data;
};

const updateVehicleCategory = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.VehicleCategory, input);
  return data;
};

const deleteVehicleCategory = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.VehicleCategory}?CompanyCode=${companyCode}&VehicleCategoryID=${code}`
  );
  return data;
};

export const useGetVehicleCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleCategory],
    queryFn: () => getAllVehicleCategories(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetVehicleCategoryByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.VehicleCategory],
    queryFn: () => getVehicleCategoryById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertVehicleCategoryMutation = () => {
  return useMutation({
    mutationFn: insertVehicleCategory,
  });
};

export const useUpdateVehicleCategoryMutation = () => {
  return useMutation({
    mutationFn: updateVehicleCategory,
  });
};

export const useDeleteVehicleCategoryMutation = () => {
  return useMutation({
    mutationFn: deleteVehicleCategory,
  });
};
